import React from 'react'
import errorLoading from '../../img/404-animation.json'
import Lottie from 'lottie-react-web'
import { MDBBtn, MDBIcon } from 'mdbreact'

const Error = () => {
    return (
        <>
        <div className="wrapper-desktop-loader d-mobile-hide">
            <div className="position-fixed d-flex flex-column w-100 h-100 text-center justify-content-center align-items-center">
                <Lottie height="75%" width="100%" options={{ animationData: errorLoading }}/>
                <h5 className="h5-responsive font-weight-bold mt-n5">
                    Sorry we couldn't find the page/content that you've been looking for.
                </h5> 
                <MDBBtn href="/" color="dark" className="text-capitalize">
                    Back Home <MDBIcon fas icon="arrow-right ml-2"/>
                </MDBBtn> 
            </div>
        </div>
        <div className="wrapper-desktop-loader d-mobile-show">
            <div className="position-fixed d-flex flex-column w-100 h-100 text-center justify-content-center align-items-center">
                <Lottie height="auto" width="100%" options={{ animationData: errorLoading }}/>
                <h5 className="h5-responsive font-weight-bold px-5 mt-n4">
                    Sorry we couldn't find the page/content that you've been looking for.
                </h5>  
                <MDBBtn size="md" href="/" color="dark" className="text-capitalize">
                    Back Home <MDBIcon fas icon="arrow-right ml-2"/>
                </MDBBtn> 
            </div>
        </div>
        </>
    )
}

export default Error
